export {
  Avatar,
  avatarVariants,
  type AvatarProps,
} from "./components/Avatar/Avatar"
